var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    className: "twitter_svg__icon--twitter"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24 2.375a10.5 10.5 0 0 1-2.467 2.61 14.7 14.7 0 0 1-.563 4.71 14.8 14.8 0 0 1-1.76 3.883 15.2 15.2 0 0 1-2.809 3.29q-1.63 1.429-3.929 2.28Q10.174 20 7.553 20 3.426 20 0 17.734q.533.063 1.188.063 3.427 0 6.106-2.156a4.72 4.72 0 0 1-2.863-1.008 4.93 4.93 0 0 1-1.736-2.492q.502.078.93.078.654 0 1.294-.172-1.706-.36-2.825-1.742C.975 8.923.974 8.313.974 7.094V7.03q1.036.594 2.224.64a5 5 0 0 1-1.599-1.796 5 5 0 0 1-.594-2.406q0-1.376.67-2.547A14 14 0 0 0 6.16 4.648a13.4 13.4 0 0 0 5.657 1.555 5.8 5.8 0 0 1-.122-1.156q0-2.094 1.44-3.57Q14.573 0 16.615 0q2.13 0 3.593 1.594A9.5 9.5 0 0 0 23.33.375a4.88 4.88 0 0 1-2.162 2.781A9.6 9.6 0 0 0 24 2.375"
  })));
};
export default SvgTwitter;